{
  "RenderCalloutForm": {
    "searchLocation": "Search location",
    "selectDate": "Select date",
    "select": "Select",
    "enterAmount": "Enter amount",
    "fileUploaderLabel": "Accepts .jpg, .png, .heic, .gif, .webp, .mp4, .mov, .pdf - (max 10mb per file)",
    "removeFile": "Remove file",
    "from": "From",
    "to": "To",
    "selectDates": "Select dates",
    "optional": "optional",
    "addLabel": "Add label",
    "addDescription": "Add a description",
    "validationError": "Validation error: Please check all fields are valid",
    "submit": "Submit",
    "emptyForm": "Select fields on the left for applicants to fill in"
  },
  "CalloutCreateModal": {
    "createCallout": "Create callout",
    "editCallout": "Edit callout",
    "duplicateCallout": "Duplicate callout",
    "callout": "Callout",
    "couldNotCreateCallout": "Could not create callout",
    "couldNotUpdateCallout": "Could not update callout",
    "details": "Details",
    "title": "Title",
    "titlePlaceholder": "Casting call for holiday shoot...",
    "defaultResourceType": "Default resource type",
    "selectResourceTypeInfo": "Select the resource type that will be set when adding an applicant",
    "resourceType": "Resource Type",
    "resourceTypePlaceholder": "Select resource type",
    "resourceTypeRequired": "Please select a resource type",
    "template": "Template",
    "templateInfo": "This will give you a suggested set of fields to start with and edit",
    "cancel": "Cancel",
    "saveChanges": "Save Changes"
  },
  "CalloutDetail": {
    "build": "Build",
    "preview": "Preview",
    "publish": "Publish",
    "applicants": "Applicants",
    "backToEdit": "Back to Edit",
    "unpublishAndEdit": "Unpublish & Edit",
    "unpublishAndEditTip": "Unpublish callout to edit"
  },
  "CalloutActions": {
    "share": "Share",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "editCallout": "Edit callout",
    "transfer": "Transfer to workspace",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "moreActions": "More actions",
    "archiveSuccess": "Callout archived",
    "unarchiveSuccess": "Callout unarchived",
    "archiveError": "Failed to archive callout: {{error}}",
    "unarchiveError": "Failed to unarchive callout: {{error}}"
  },
  "CalloutDialog": {
    "createCallout": "Create callout",
    "editCallout": "Edit callout",
    "duplicateCallout": "Duplicate callout",
    "duplicate": "Duplicate",
    "details": "Details",
    "template": "Template",
    "templateInfo": "This will give you a suggested set of fields to start with and edit",
    "slug": "URL slug",
    "slugInvalid": "Use lowercase letters, numbers, and hyphens only",
    "slugRequired": "Slug is required",
    "slugSyncFromTitle": "Sync from title",
    "slugUuidDisallowed": "Slug cannot look like a UUID",
    "slugDuplicate": "This slug is already in use",
    "next": "Next",
    "back": "Back",
    "backWithArrow": "← Back",
    "cancel": "Cancel",
    "create": "Create callout",
    "saveChanges": "Save changes",
    "selectTemplate": "Select template",
    "selectTemplateHint": "Select a template",
    "templateSelectedCount": "{{count}} selected",
    "unselectAll": "Unselect All",
    "unselectAllTemplates": "Unselect all templates",
    "templateFieldCount": "{{count}} fields",
    "couldNotCreateCallout": "Could not create callout",
    "couldNotUpdateCallout": "Could not update callout"
  },
  "templates": {
    "basicCallout": {
      "name": "💁🏽‍♂️️ Basic callout",
      "description": "A basic form to capture contact information",
      "mappings": {
        "full_name": {
          "label": "Full name",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": ""
        },
        "phone_number": {
          "label": "Phone number",
          "description": ""
        },
        "websites": {
          "label": "Website link (URL)",
          "description": ""
        },
        "locations": {
          "label": "Address",
          "description": "Search for and select an address below"
        }
      }
    },
    "portfolioCallout": {
      "name": "📸 Portfolio callout",
      "description": "A form to capture contact information and samples of work",
      "mappings": {
        "full_name": {
          "label": "Full name",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": ""
        },
        "phone_number": {
          "label": "Phone number",
          "description": ""
        },
        "websites": {
          "label": "Website",
          "description": ""
        },
        "locations": {
          "label": "Location",
          "description": "Where are you based?"
        },
        "files": {
          "label": "Upload samples",
          "description": "Upload at least three samples of work below"
        }
      }
    },
    "modelCallout": {
      "name": "⭐️ Model callout",
      "description": "A form to capture model information for casting",
      "mappings": {
        "full_name": {
          "label": "Full name",
          "description": ""
        },
        "emails": {
          "label": "Email",
          "description": "Please enter your personal / agent's email address"
        },
        "phone_number": {
          "label": "Phone number",
          "description": "Please enter your personal / agent's phone number"
        },
        "websites": {
          "label": "Website link (URL)",
          "description": "A link to your portfolio"
        },
        "social_instagram": {
          "label": "Instagram",
          "description": "If you have a relevant Instagram account, please enter the handle below"
        },
        "locations": {
          "label": "Location",
          "description": "Where are you based?"
        },
        "files": {
          "label": "Portfolio Images",
          "description": "Upload at least 3 images of previous work"
        }
      }
    }
  },
  "fieldMappings": {
    "social_instagram": "Instagram",
    "social_twitter": "Twitter",
    "social_behance": "Behance",
    "social_youtube": "Youtube",
    "social_vimeo": "Vimeo",
    "profile_picture": "Profile picture",
    "full_name": "Full name",
    "files": "Media uploader",
    "role": "Role",
    "websites": "Website",
    "emails": "Email",
    "phone_numbers": "Phone number",
    "locations": "Location",
    "rates": "Rate",
    "tags": "Tags",
    "groups": "Groups"
  },
  "CalloutForm": {
    "termsSection": "Terms & Conditions section",
    "termsTitle": "Terms & Conditions",
    "termsTitlePlaceholder": "Terms and conditions title",
    "termsContentPlaceholder": "Terms and conditions content",
    "termsCheckboxLabelPlaceholder": "Confirmation text",
    "termsPrivacyNotice": "Privacy notice: By submitting this application, you consent to the collection and processing of your personal information for casting and booking purposes. Your information will be used to evaluate your suitability for our campaigns and may be shared with our production partners. Participation is voluntary, and you may withdraw your application at any time by contacting us. We are committed to protecting your privacy and will handle your data in accordance with applicable privacy laws.",
    "termsRequired": "You must agree to the terms and conditions",
    "termsCheckboxLabel": "I agree to the outlined terms and conditions",
    "submitError": "An error occurred while submitting the form. Please try again.",
    "submitting": "Submitting...",
    "submitApplication": "Submit Application",
    "successTitle": "Application Submitted",
    "successMessage": "Thank you for your application. We will be in touch if we think you are a good fit for the projects we have.",
    "submitAnother": "Submit another application"
  },
  "ApplicantSubmittedModal": {
    "title": "Application Submitted",
    "thanksMessage": "Thanks for your submission. We'll be in touch shortly",
    "successMessage": "Thank you for your application. We will be in touch if we think you are a good fit for the projects we have.",
    "submitAnother": "Submit another application"
  },
  "CalloutFormControls": {
    "invalidEmail": "Invalid email address",
    "locationPlaceholder": "Select a location",
    "locationSearchPrompt": "Search for a location",
    "locationEmpty": "No locations found",
    "locationUseTypedText": "Use \"<query></query>\""
  },
  "CalloutBuilderField": {
    "dragToReorder": "Drag to reorder {{name}}",
    "labelPlaceholder": "Add label",
    "descriptionPlaceholder": "Add description",
    "required": "Required",
    "remove": "Remove {{name}}"
  },
  "TransferCalloutDialog": {
    "title": "Transfer to workspace",
    "description_one": "Move {{name}} to another workspace.",
    "description_other": "Move {{count}} callouts to another workspace.",
    "fieldWorkspace": "Destination workspace",
    "success_one": "Callout transferred",
    "success_other": "{{count}} callouts transferred"
  }
}
